export const IMO_WATERMARK = `Powered by IMO® Terminology. © ${new Date().getFullYear()}`;
export const WITH_REFINABLE = '3';
export const REFINABLE_TEXT = 'Refinable';
export const SECONDARYICD10_CODE = 'secondaryIcd10Code';
export const SECONDARYICD10_TEXT = 'secondaryIcd10Text';

export const APPOINTMENT_STATUS_FREE = 'free';
export const ANONYMOUS_USER = 'anonymous';
export const NLM_SEARCH_ENABLED = 'nlmSearchEnabled';
export const SCHEDULING_LAZY_LOAD_FLAG = 'SchedulingLazyLoadingEnabled';
export const CLINICIAN_ROUTING_FLAG = 'clinicianRoutingEnabled';
export const ENFORCE_CREATE_ROUTE_FLAG = 'enforceCreateRouteEnabled';
export const REMOVE_ROUTE_FLAG = 'removeRouteEnabled';
export const RELEASE_ADMISSION_CONSENT_FLAG = 'release-admission-consent';
/** LaunchDarkly: enable per-form active time tracking during an encounter */
export const RELEASE_ENCOUNTER_ACTIVITY_TRACKING_FLAG =
  'release-encounter-activity-tracking';
export const AVAILABILITY_EXCEPTION_FLAG = 'availabilityException';
export const SHOW_HOME_HEALTH_ICON_FLAG = 'release_home_health';
export const ROUTE_REPORT_FLAG = 'routeReportEnabled';
export const ADD_BREAK_FEATURE_FLAG = 'release-route-breaks';
/** LaunchDarkly: use FHIR USPS ValueSet (full state list) for address state when legal entities are loaded */
export const RELEASE_ADDRESS_ALL_US_STATES_FLAG =
  'release-address-all-us-states';
export const RE_OPTIMIZE_ROUTE_FLAG = 'reOptimizeRouteButton';
export const EDIT_ROUTE_MILES_FLAG = 'editRouteMilesEnabled';
export const SHOW_PATIENT_NAME_ON_MAP_FLAG = 'showPatientNameOnMap';
export const ENCOUNTER_FILTERS_FLAG = 'enableEncounterFilters';
export const APPOINTMENT_RESCHEDULE_REASON_FLAG = 'release-reschedule-flow';
export const RELEASE_PATIENT_LANGUAGE_FEATURE_FLAG =
  'release-patient-language-feature';
export const VERBAL_CONSENT = 'release-verbal-consent';
export const REJOIN_SFMC_WEBHOOK = 'release-rejoin-sfmc-webhook';
export const INDIVIDUAL_ELIGIBILITY_CHECK_FLAG =
  'individualEligibilityCheckEnabled';
export const OFFLOADING_TREATMENT_MANDATORY_FLAG =
  'release-offloading-treatment';
export const ENHANCE_WAT_FORM_LOADING_FLAG = 'release-optimize-wat';
export const RELEASE_EVAL_ONLY_WAT_MANDATORY_FLAG =
  'release-eval-only-wat-mandatory';
export const RELEASE_ROUTE_OPTIMIZATION = 'release-route-optimization';
export const RELEASE_REALTIME_TRAFFIC_GOOGLEMAP =
  'release-realtime-traffic-googlemap';
export const RELEASE_TREATMENT_SUPPLIES = 'release-treatment-supplies';
export const RELEASE_HOME_HEALTH = 'release_home_health';
export const RELEASE_DSI_DASHBOARD = 'release-dsi-dashboard';
export const RELEASE_PDSI_FEATURE_FLAG = 'release-pdsi-feature';
export const RELEASE_APPT_MISSED_HIDDEN = 'release-appt-miss-hidden';
export const RELEASE_MILEIQ_FLAG = 'release-mileiq';
export const MILEIQ_MILEAGE_THRESHOLD = 'mileiq-mileage-threshold';
export const USER_FILTER_FLAG = 'release-user-filter';
export const RELEASE_OM_PATIENT = 'release-om-appointment-therapy';
export const RELEASE_OM_APPOINTMENT_THERAPY_TASK_FLAG =
  'release-om-appointment-therapy-task';
export const RELEASE_OM_APPOINTMENT_ULTRA_THERAPY_TASK_FLAG =
  'release-om-appointment-ultrasound-therapy';
export const BIOFILM_TISSUE_WOUND_ASSESSMENT_FLAG =
  'release-biofilm-tissue-wound-assessment';
export const RELEASE_ENCOUNTER_DATE_FIX = 'release-encounter-date-fix';
export const CREATE_ROUTE_PAST_DAY = 'release-create-route-for-past-days';
export const COVERAGE_TYPE_ENABLED_FLAG = 'release-coverage-type-selection';
export const COVERAGE_TYPE_OPTION = ['Medicare', 'Managed Care'];
export enum CoverageType {
  MEDICARE = 'medicare',
  MANAGED_CARE = 'managed-care',
}
export const MEDICARE = 'medicare';
export const RELEASE_WAT_SKIN_SUBSTITUTE_THERAPY =
  'release-wat-skin-sub-therapy';
export const RELEASE_GENDER_LABEL_CHANGE = 'release-gender-label-change';
export const RELEASE_DEBRIDEMENT_TISSUE_TYPE =
  'release-debridement-tissue-types';
export const RELEASE_PATIENT_LANGUAGE_FEATURE =
  'release-patient-language-feature';
export const PREFERRED_LANGAUAGES =
  'http://woundtech.net/fhir/CodeSystem/preferred-languages'; // NOSONAR
export const SUPPORTED_LANGUAGES =
  'http://woundtech.net/fhir/CodeSystem/supported-languages'; // NOSONAR
export const LANGUAGE_DEFINITION =
  'http://woundtech.net/fhir/StructureDefinition/language-definition'; // NOSONAR
export const LANGUAGE_PROPERTY =
  'http://woundtech.net/fhir/StructureDefinition/language-property'; // NOSONAR
export const HOME_HEALTH_V2_FLAG = 'release-prod-home-health-v2';
export const HOME_HEALTH_TYPE_CODES = ['hha', 'home-health'];
export const RELEASE_WOUNDHUB_REFERRAL_FLAG = 'release-woundhub-referral';
export const RELEASE_PATIENT_ATTRIBUTION_FLAG = 'release-patient-attribution';
export const LAB_TESTS = 'http://woundtech.net/fhir/CodeSystem/lab-tests'; // NOSONAR
export const RELEASE_CQM_STORE_EXPORT = 'release-cqm-store-export'; // NOSONAR
export const RELEASE_IMPLANTABLE_DEVICES_FLAG = 'release-implantable-devices';
export const RELEASE_COMM_TOPIC_FILTER_FLAG = 'release-comm-topic-filter'; // NOSONAR
// LaunchDarkly feature flag key for password reset v2 functionality (not a password value)
export const RELEASE_RESET_PWD_V2_FLAG = 'release-reset-pwd-v2'; // NOSONAR
export const RELEASE_TRANSITION_OF_CARE_FLAG = 'release-transition-of-care';
export const RELEASE_DIRECT_MESSAGE_INBOX_FLAG = 'release-direct-message-inbox';
export const RELEASE_ONC_TESTER_FLAG = 'release-onc-tester';
export const RELEASE_CQM_IMPORT_ONC_TEST_DATA_FLAG =
  'release-cqm-import-onc-test-data';
export const RELEASE_ONC_TOC_SEND_WITHOUT_ATTACHMENT_FLAG =
  'release-onc-toc-send-without-attachment';
export const RELEASE_ONC_TOC_ADDL_PATIENT_DATA =
  'release-onc-toc-addl-patient-data-load';
export const RELEASE_ONCE_RACE_ETHNICITY_MINIMAL_FLAG =
  'release-race-ethnicity-dd-onc';
export const RELEASE_ONC_VITAL_SIGN_LAB_REPORTS_OPTIONS_FLAG =
  'release-onc-vital-sign-lab-reports-options';
export const RELEASE_ONC_SMOKING_START_DATE_FLAG =
  'release-onc-smoking-start-date';
export const RELEASE_LAB_CLINICAL_TESTS = 'release-lab-clinical-tests';
export const RELEASE_ONC_CODE_NAME_CHANGE_SNOMED_FLAG =
  'release-onc-codename-change-snowmed';
export const RELEASE_LAUNCH_AI_WOUND_ANALYZER =
  'release-launch-ai-wound-analyzer';
// Event names for notifications
export const EVENT_NAMES = {
  EHI_EXPORT: 'Ehi Export',
  EHI_EXPORT_FAILED: 'Ehi Export Failed',
  BULK_QRDA_EXPORT: 'Bulk QRDA Export',
  BULK_QRDA_EXPORT_FAILED: 'Bulk QRDA Export Failed',
  WOUND_ANALYZER_RESULT_READY_EVENT_TITLE: 'Wound Analyzer Results Ready',
  WOUND_ANALYZER_PROCESSING_FAILED_EVENT_TITLE:
    'Wound Analyzer Processing Failed',
  AUDIO_TRANSCRIPT_READY_EVENT_TITLE: 'Audio transcript is ready',
  AUDIO_TRANSCRIPT_FAILED_EVENT_TITLE: 'Audio transcript failed',
} as const;
export const RELEASE_CQM_SHOW_PATIENT_REF_SEARCH_BATCH_EXPORT =
  'release-cqm-show-patient-ref-search-batch-export';

export const WOUND_ANALYZER_RESULT_READY_MESSAGE =
  'AI Wound Analyzer results are ready. Click below link to review them in the Wound Assessment and Treatment Form.';
export const WOUND_ANALYZER_PROCESSING_FAILED_MESSAGE =
  'Sorry, AI-suggested data could not be generated at this time. Please complete the Wound Assessment and Treatment Form manually.';
export const AUDIO_TRANSCRIPT_READY_MESSAGE = 'Your audio transcript is ready.';
export const AUDIO_TRANSCRIPT_FAILED_MESSAGE =
  'Transcription failed. Please try again.';
export const WOUND_ANALYZER_RESULT_READY_RELOAD_MESSAGE =
  'AI Wound Analyzer results are ready. Please reload this page to review them in the Wound Assessment and Treatment Form.';
export const WOUND_ANALYZER_PROCESSING_FAILED_RELOAD_MESSAGE =
  'AI Wound Analyzer could not generate suggestions. Please reload this page to dismiss the in-progress message and continue the Wound Assessment and Treatment Form manually.';
export const WOUND_ANALYZER_DOCUMENTATION_DISCLAIMER =
  'AI-Assisted Documentation Notice:\nPortions of this clinical documentation, including certain measurements and data extraction, may have been generated or supported by artificial intelligence (AI)-enabled tools operating under clinician oversight and supervision. These tools are used solely to assist with documentation and workflow processes and are not used to independently make diagnoses, treatment recommendations, medical necessity determinations, or other clinical decisions. All AI-assisted content and quantitative measurements were reviewed, validated, and modified as appropriate by the treating and/or interpreting clinician. The clinician retains sole responsibility for all professional judgment and for the accuracy, completeness, and final content of the medical record.';
export const WOUND_ANALYZER_STOP_PROCESSING_LABEL = 'Stop AI Processing';
export const WOUND_ANALYZER_PROCESSING_STOPPED_MESSAGE =
  'AI processing has been stopped. You may continue documenting the wound assessment manually.';
export const WOUND_ANALYZER_STOP_PROCESSING_FAILED_MESSAGE =
  'AI processing was stopped locally, but the request could not be cancelled on the server. You may continue documenting the wound assessment manually.';
export const WOUND_ANALYZER_SECTION_DISCLAIMER =
  'AI-generated recommendations are intended to assist clinicians and must be reviewed and validated before use. Clinical judgment remains the responsibility of the treating clinician.';
export const RELEASE_ROUTE_CHECK_IN_GUARD_RAILS_FLAG =
  'release-route-check-in-guard-rails';

export const RELEASE_WOUNDSCRIBE_ENABLED_FLAG =
  'ws-release-woundscribe-enabled';

export const RELEASE_AI_USE_ADMISSION_CONSENT_FLAG =
  'release-ai-use-admission-consent';
// Off for MVP (one recording or upload per encounter). Turn on after MVP success.
export const ALLOW_MULTIPLE_RECORDINGS_FLAG = 'ws-allow-multiple-recordings';
